import { Action } from '@ngrx/store';

export enum ZalamoInlineHelpClientActionTypes {
  LoadZalamoInlineHelpClients = '[ZalamoInlineHelpClient] Load ZalamoInlineHelpClients',
  
  
}

export class LoadZalamoInlineHelpClients implements Action {
  readonly type = ZalamoInlineHelpClientActionTypes.LoadZalamoInlineHelpClients;
}


export type ZalamoInlineHelpClientActions = LoadZalamoInlineHelpClients;
